var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLockerUnlock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "locker_unlock_icon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(11 6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.752,27.055H23.088V20.2a8.76,8.76,0,0,1,16.629-3.851,1.827,1.827,0,0,0,2.447.828c.042-.02.083-.043.122-.067a1.892,1.892,0,0,0,.643-2.486,12.411,12.411,0,0,0-23.5,5.575v6.857h-3.6a3.523,3.523,0,0,0-3.522,3.522V52.364a3.525,3.525,0,0,0,3.522,3.522h30.91a3.525,3.525,0,0,0,3.522-3.522V30.576A3.525,3.525,0,0,0,46.752,27.055Zm-.129,25.182H15.969V30.7H46.623Z",
    transform: "translate(-12.31 -7.787)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.486,40.169v2.288a1.721,1.721,0,0,0,3.44,0V40.169a2.947,2.947,0,1,0-3.44,0Z",
    transform: "translate(-11.223 -5.82)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockerUnlock);
export default __webpack_public_path__ + "static/media/locker_unlock.ef7251ef77c114f9e1f3f75e6238a0f2.svg";
export { ForwardRef as ReactComponent };